export default {"src":"/_next/static/media/suggestions-active-icon.509b7e28.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};